import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=2bcb52f9&"
import script from "./Code.vue?vue&type=script&lang=js&"
export * from "./Code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports